import React from 'react'
import CoordinatorApartmentList from '../../features/coordinator/CoordinatorApartmentList'

const CoordinatorApartmentListPage = () => {
  return (
  <CoordinatorApartmentList/>
  )
}

export default CoordinatorApartmentListPage